import { Injectable } from "@angular/core";
import * as CryptoJS from 'crypto-js';  

@Injectable()
export class CryptoJs{

    //private encPassword: string = "3s6v9y$B&E)H@McQfTjWnZq4t7w!z%C*";
    //private decPassword: string = "3s6v9y$B&3)H@McQfT4WnZqWt7w!z%C*";

    constructor() { }

    public encrypt(plainText: string, encPassword:string) {
        return CryptoJS.AES.encrypt(plainText.trim(), encPassword.trim()).toString();
    }

    public decrypt(encryptText: string, decPassword:string) {
        return CryptoJS.AES.decrypt(encryptText.trim(), decPassword.trim()).toString(CryptoJS.enc.Utf8);
    }

}
